import { tableConfig } from './tables';

// SECURITY
export const loginPath = () => '/api/v1/adm/users/sign-up/login';
export const tokenIntervalsPath = () =>
  '/api/v1/adm/users/find-token-intervals';
export const refreshTokenPath = () => `/api/v1/adm/users/refresh-token`;

// 2FA - ()
export const verify2faPath = (userId) =>
  `/api/v1/adm/users/sign-up/verify-2fa/${userId}`;
export const register2faPath = (id) => `/api/v1/adm/users/register-2fa/${id}`;
export const deactivate2faPath = (id) =>
  `/api/v1/adm/users/deactivate-2fa/${id}`;
export const userActivate2faPath = (id) =>
  `/api/v1/adm/users/activate-2fa/${id}`;

// USER
export const userPath = () => '/api/v1/adm/users';
export const userIdPath = (id) => `/api/v1/adm/users/${id}`;
export const userPageablePath = (pageNumber, pageSize) =>
  `/api/v1/adm/users/${pageNumber}/${pageSize}`;
export const userDeactivatePath = (id) => `/api/v1/adm/users/deactivate/${id}`;
export const userActivatePath = (id) => `/api/v1/adm/users/activate/${id}`;
export const userResetPasswordPath = () => `/api/v1/adm/users/reset-password`;
export const userUsernameGeneratorPath = (firstName, lastName) =>
  `/api/v1/adm/users/generate-username/${firstName}/${lastName}`;
export const userPasswordGeneratorPath = () =>
  `/api/v1/adm/users/generate-random-password`;
export const usernameGeneratorSignalPath = () =>
  `/api/v1/adm/users/find-username-generator-signal`;

export const appVersionAndLocalePath = () =>
  `/api/v1/adm/users/find-app-version-and-locale`;
export const passwordChangePath = () =>
  `/api/v1/adm/users/password-change-from-login`;
export const userLoginHistoryPath = (id) =>
  `/api/v1/adm/users/login-history/${id}`;
export const saveUserFastLink = () => `/api/v1/adm/users/fast-link-save`;
export const userUnlockPath = (id) => `/api/v1/adm/users/unlock/${id}`;
export const sendPasswordChangeLinkPath = (email) =>
  `/api/v1/adm/users/forgotten-password/send-password-change-link/?email=${email}`;
export const checkPasswordChangeLinkPath = (uuid) =>
  `/api/v1/adm/users/forgotten-password/check-password-change-link/${uuid}`;
export const passwordChangeFromLinkPath = (uuid) =>
  `/api/v1/adm/users/forgotten-password/password-change/${uuid}`;
export const checkPasswordCreateLinkPath = (uuid) =>
  `/api/v1/adm/users/user-password-creation/check-password-create-link/${uuid}`;
export const passwordCreateFromLinkPath = (uuid) =>
  `/api/v1/adm/users/user-password-creation/password-create/${uuid}`;

// ROLE

export const rolePath = () => '/api/v1/adm/roles';
export const roleIdPath = (id) => `/api/v1/adm/roles/${id}`;
export const roleFetchAllDTOPath = () => `/api/v1/adm/roles/find-all-roles-dto`;
export const rolePageablePath = (pageNumber, pageSize) =>
  `/api/v1/adm/roles/${pageNumber}/${pageSize}`;
export const roleFetchAllHashMapListPath = () =>
  `/api/v1/adm/roles/find-all-roles-hash-map-list`;
export const roleAddAndReturnRoleDTOPath = () =>
  '/api/v1/adm/roles/create-and-return-role-dto';
export const actionsFetchAllPath = () => `/api/v1/adm/roles/find-all-actions`;

// CHANNEL
export const channelPath = () => '/api/v1/tbl/channels';
export const channelPageablePath = (pageNumber, pageSize) =>
  `/api/v1/tbl/channels/?page=${pageNumber}&size=${pageSize}&sort=`;
export const channelIdPath = (id) => `/api/v1/tbl/channels/${id}`;

// ADMINISTRATION
export const administrationRulesPageablePath = (pageNumber, pageSize) =>
  `/api/v1/tbl/table-settings/?page=${pageNumber}&size=${pageSize}&sort=`;
export const administrationRulesListPath = () =>
  `/api/v1/tbl/table-settings/list`;
export const administrationFilterSettingsPath = (tableName, language = 'SR') =>
  `/api/v1/tbl/tables/${tableName}/filter-settings?language=${language}`;
export const administrationTableSettingsPath = (id, language = 'SR') =>
  `/api/v1/tbl/tables/${id}/table-settings?language=${language}`;
export const administrationTableActionsSettingsPath = (id, language = 'SR') =>
  `/api/v1/tbl/tables/${id}/table-actions-settings?language=${language}`;
export const updateFilterSettingsPath = (language = 'SR') =>
  `/api/v1/tbl/table-settings/filters?language=${language}`;
export const updateTableSettingsPath = (language = 'SR') =>
  `/api/v1/tbl/table-settings/table?language=${language}`;
export const updateTableActionsSettingsPath = (language = 'SR') =>
  `/api/v1/tbl/table-settings/table-actions?language=${language}`;

// FILTER
export const filterPageablePath = () => `/api/v1/adm/users/search`;
export const findTableSettingsPath = (table) =>
  `/api/v1/tbl/tables/${table}/table-settings`;
export const findAllAttributesPath = (table) =>
  `/api/v1/tbl/tables/${table}/filter-settings`;
export const filterAttributesPath = (table, limit) =>
  `/api/v1/tbl/tables/${table}?limit=${limit}`;

// ADMIN PANEL
export const appHealthDataFetchPath = () => `/actuator/health`;
export const appInfoDataFetchPath = () => `/actuator/info`;
export const appStartupInfoFetchPath = () =>
  `/actuator/metrics/process.start.time`;
export const auditLoginEventsFetchPath = () => `/actuator/auditevents`;
export const httpTraceFetchPath = () => `/actuator/httptrace`;

// MONITORING
export const monitoringLastSynchronizationPath = () =>
  `/api/v1/tbl/tables/${tableConfig.MONITORING.name}/last-synchronization`;

// UPLOAD DOKUMENTA
export const uploadAttachmentPath = () => `/api/v1/adm/attachment`;
export const uploadAttachmentDocumentPath = () =>
  `/api/v1/adm/attachment/document/`;

//ŠIFARNICI
export const codebookTypePath = () => '/api/v1/code/codebook-types';
export const codebookTypeIdPath = (id) => `/api/v1/code/codebook-types/${id}`;
export const codebookPath = () => '/api/v1/code/codebooks';
export const codebookIdPath = (id) => `/api/v1/code/codebooks/${id}`;
export const codebookFindAllChildrenByCodebookTypePath = (codebookTypeId) =>
  `/api/v1/code/codebooks/parent/${codebookTypeId}`;
export const codebookTypeCompositePath = () =>
  `/api/v1/code/codebook-types/hierarchical`;
export const codebookDeactivatePath = (id) =>
  `/api/v1/code/codebooks/deactivate/${id}`;
export const codebookActivatePath = (id) =>
  `/api/v1/code/codebooks/activate/${id}`;
export const codebookTypeDeactivatePath = (id) =>
  `/api/v1/code/codebook-types/deactivate/${id}`;
export const codebookTypeActivatePath = (id) =>
  `/api/v1/code/codebook-types/activate/${id}`;
export const codebooksByTypeInactivePath = (codebookTypeId) =>
  `/api/v1/code/codebooks/inactive/${codebookTypeId}`;
export const parentCodebookNamesPath = (codebookTypeId) =>
  `/api/v1/code/codebooks/parentCodebooks/${codebookTypeId}`;
export const codebooksForFormFetchPath = () =>
  `/api/v1/code/codebooks/codebooks-for-form`;
export const codebooksStreetFetchPath = (typeCode, parentCode) =>
  `/api/v1/code/codebooks/codebook-type-parent-codebook/${typeCode}/${parentCode}`;

//CODEBOOK TYPE GROUP
export const codebookTypeGroupPath = () => '/api/v1/code/codebook-type-group';
export const codebookTypeGroupIdPath = (id) =>
  `/api/v1/code/codebook-type-group/${id}`;

//CODEBOOK COLUMN
export const codebookColumnIdPath = (id) => `/api/v1/code/codebookcolumn/${id}`;
export const codebookColumnPath = () =>
  '/api/v1/code/codebookcolumn/create-bulk';
export const codebookColumnFindAllByCodebookTypePath = (codebookTypeId) =>
  `/api/v1/code/codebookcolumn/${codebookTypeId}`;
export const codebookColumnPathCreate = () =>
  '/api/v1/code/codebookcolumn/create';
export const codebookColumnPathUpdate = () => '/api/v1/code/codebookcolumn';
export const codebookColumnDeleteMultiplePath = (codebookTypeId) =>
  `/api/v1/code/codebookcolumn/delete-multiple/${codebookTypeId}`;

//CODEBOOK COLUMN VALUES
export const codebookColumnValueFindAllPath = (codebookId) =>
  `/api/v1/code/codebook-column-values/${codebookId}`;
export const codebookColumnValuePath = () =>
  `/api/v1/code/codebook-column-values`;
export const codebookColumnValuesListFindAllPath = () =>
  `/api/v1/code/codebook-column-values/list`;

export const fetchCodebooksListNonPageable = (type) =>
  `/api/v1/code/codebooks/list?code=${type}`;

//COMPILATIONS
export const compilationPath = () => '/api/v1/comp/compilations';
export const compilationIdPath = (id) => `/api/v1/comp/compilations/${id}`;

//BUSINESS PARTNER
export const businessPartnerListPath = () =>
  '/api/v1/comp/business-partners/list';
